import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { loadCSMSDK } from '../../common/utils/load-js-sdk';
import { useEvent } from '../../controllers/use-event';
import { useLatestHandlers } from '../../controllers/use-latest';
var NOOP = function NOOP() {};
var stringifyError = function stringifyError(error) {
  if (typeof error === 'string') {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Unknown error';
};
export var CSMWidgetEmbed = function CSMWidgetEmbed(_ref) {
  var settingsProp = _ref.settings,
    sdk = _ref.sdk,
    onChatStatusProp = _ref.onChatStatus,
    onChatMessage = _ref.onChatMessage,
    onErrorProp = _ref.onError,
    onDebugProp = _ref.onDebug;
  var _useState = useState(settingsProp),
    _useState2 = _slicedToArray(_useState, 1),
    settings = _useState2[0];
  var containerRef = useRef(null);
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    embed = _useState4[0],
    setEmbed = _useState4[1];
  var chatMessageEventHandlers = useLatestHandlers(onChatMessage);
  var onChatStatus = useEvent(onChatStatusProp !== null && onChatStatusProp !== void 0 ? onChatStatusProp : NOOP);
  var onError = useEvent(onErrorProp !== null && onErrorProp !== void 0 ? onErrorProp : NOOP);
  var _debug = useEvent(onDebugProp !== null && onDebugProp !== void 0 ? onDebugProp : NOOP);
  useEffect(function () {
    _debug({
      message: '[ReactSDK]: mounted'
    });
    return function () {
      _debug({
        message: '[ReactSDK]: unmounted'
      });
    };
  }, [_debug]);
  useEffect(function () {
    var bindEmbedInstance = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var CSM, instance, events, bindEvent;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _debug({
                message: '[ReactSDK]: loading CSM SDK'
              });
              _context.next = 4;
              return loadCSMSDK({
                site: settings.site,
                debug: _debug
              });
            case 4:
              CSM = _context.sent;
              if (containerRef.current) {
                _context.next = 8;
                break;
              }
              _debug({
                message: '[ReactSDK]: embed target container ref not found'
              });
              throw new Error('Container element not found');
            case 8:
              _debug({
                message: '[ReactSDK]: creating CSM.embed instance'
              });
              instance = CSM.embed(containerRef.current, settings, {
                debug: function debug(message) {
                  _debug({
                    message: message
                  });
                }
              });
              events = ['before', 'started', 'aborted', 'completed', 'failed'];
              bindEvent = function bindEvent(event) {
                instance.on("message:".concat(event), function () {
                  var _chatMessageEventHand, _chatMessageEventHand2;
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }
                  // @ts-ignore
                  (_chatMessageEventHand = chatMessageEventHandlers.current) === null || _chatMessageEventHand === void 0 || (_chatMessageEventHand2 = _chatMessageEventHand[event]) === null || _chatMessageEventHand2 === void 0 || _chatMessageEventHand2.call.apply(_chatMessageEventHand2, [_chatMessageEventHand].concat(args));
                });
              };
              events.forEach(function (event) {
                bindEvent(event);
              });
              instance.on('status', function (payload) {
                _debug({
                  message: "[ReactSDK]: received status message ".concat(payload.status)
                });
                onChatStatus(payload.status);
              });
              instance.on('error', function (error) {
                _debug({
                  message: '[ReactSDK]: received error message'
                });
                onError(error);
              });
              setEmbed(instance);
              _debug({
                message: '[ReactSDK]: embed setup complete'
              });
              _context.next = 23;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](0);
              _debug({
                message: '[ReactSDK]: error caught'
              });
              onError({
                message: stringifyError(_context.t0)
              });
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 19]]);
      }));
      return function bindEmbedInstance() {
        return _ref2.apply(this, arguments);
      };
    }();
    bindEmbedInstance();
  }, [settings, chatMessageEventHandlers, onChatStatus, onError, _debug]);
  useImperativeHandle(sdk, function () {
    return embed;
  }, [embed]);

  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    style: {
      width: '100%',
      height: '100%'
    }
  });
};